module.exports = "<button type=\"button\" class=\"btn\" [ngClass]=\"buttonClass\" [disabled]=\"disabled\" (click)=\"onClickButton($event)\">\n    {{ buttonText }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/button/button.html
// module id = F5YW
// module chunks = 3